import React from 'react';
import { Button } from '../ui/button';
import { FileText, Download, Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

export function InvoicesDialog({
  paymentHistory,
  loadingHistory,
  downloadingInvoice,
  onLoadHistory,
  onDownloadInvoice,
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button 
          onClick={onLoadHistory}
          className="flex flex-col items-center gap-2 p-4 bg-slate-800/50 rounded-2xl hover:bg-slate-800 transition-colors border border-slate-700/50"
        >
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-orange-500 to-amber-600 flex items-center justify-center">
            <FileText className="h-5 w-5 text-white" />
          </div>
          <span className="text-sm text-white">Invoices</span>
        </button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-md max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-orange-500 to-amber-600 flex items-center justify-center">
              <FileText className="h-4 w-4 text-white" />
            </div>
            PDF Invoices
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 pt-4">
          {loadingHistory ? (
            <div className="flex justify-center py-8">
              <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
            </div>
          ) : paymentHistory.length === 0 ? (
            <p className="text-slate-400 text-center py-8">No invoices available</p>
          ) : (
            paymentHistory.map((payment) => (
              <div key={payment.payment_id} className="p-3 bg-slate-700/50 rounded-lg flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <FileText className="h-8 w-8 text-orange-400" />
                  <div>
                    <p className="text-white font-medium">Invoice #{payment.payment_id.slice(-8)}</p>
                    <p className="text-slate-400 text-xs">
                      {payment.amount} {payment.currency} • {new Date(payment.created_at).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <Button
                  size="sm"
                  onClick={() => onDownloadInvoice(payment.payment_id)}
                  disabled={downloadingInvoice === payment.payment_id}
                  className="bg-orange-500 hover:bg-orange-400"
                >
                  {downloadingInvoice === payment.payment_id ? (
                    <Loader2 className="h-4 w-4 animate-spin" />
                  ) : (
                    <>
                      <Download className="h-4 w-4 mr-1" />
                      PDF
                    </>
                  )}
                </Button>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default InvoicesDialog;
